import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import MyDashboard from "./MyDashboard";
import TeamDashboard from "./TeamDashboard";
import Leaderboard from "./Leaderboard";
import Sessions from "./Events";
import Events from "./Events";
import Environments from "./Environments";
import CreateEvent from "./CreateEvent";
import Metaverse from "./Metaverse";
import { useSelector } from "react-redux";
import EditEvent from "./EditEvent";
import EventDetails from "./EventDetails";
import TeamEngagement from "./TeamEngagement";
import UserEngagement from "./UserEngagement";
import HomePage from "./HomePage";
import PlayEnv from "./PlayEnv";
import MeetLand from "./MeetLand";
import EventScreen from "./EventScreen";

const AppRouter = ({ setSideBar, defaultRoute }) => {
  const userData = useSelector((state) => state.userSlice);
  let navigate = useNavigate();
  let permissions = userData.user.permissions || [];
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);

  useEffect(() => {
    if (defaultRoute) navigate(defaultRoute);
  }, [defaultRoute]);

  return (
    <>
      <Routes>
        {permissions.includes("METAVERSE.DASHBOARD.OWN") && <Route path="/dashboard/:uuid" element={<MyDashboard />} />}
        {permissions.includes("METAVERSE.DASHBOARD.TEAM") && (
          <Route path="/team/user/:uuid" element={<MyDashboard />} />
        )}
        {permissions.includes("METAVERSE.DASHBOARD.TEAM") && (
          <Route path="/team/dashboard/:uuid" element={<TeamDashboard />} />
        )}
        {permissions.includes("METAVERSE.DASHBOARD.OWN") && (
          <Route path="/user/:page/list/:uuid" element={<UserEngagement />} />
        )}
        {permissions.includes("METAVERSE.DASHBOARD.TEAM") && (
          <Route path="/team/:page/list/:uuid" element={<TeamEngagement />} />
        )}
        {permissions.includes("METAVERSE.LEADERBOARD") && <Route path="/leaderboard" element={<Leaderboard />} />}
        {permissions.includes("METAVERSE.EVENTS") && (
          <Route path="/events" element={<Events setSideBar={setSideBar} />} />
        )}
        {permissions.includes("METAVERSE.EVENTS") && <Route path="/events/:id" element={<EditEvent />} />}
        {permissions.includes("METAVERSE.EVENTS") && <Route path="/events/details/:id" element={<EventDetails />} />}
        {permissions.includes("METAVERSE.EVENTS") && <Route path="/events/create" element={<CreateEvent />} />}
        {permissions.includes("METAVERSE.ENVIRONMENT.VIEW") && (
          <Route path="/environments/list" element={<Environments />} />
        )}
        {configData.visibleSections.includes("home") && <Route exact path="/" element={<HomePage />} />}
        <Route path="/play/:id" element={<PlayEnv />} />
        <Route path="/invite/:id" element={<EventScreen />} />
        <Route path="*" element={<Navigate to={userData.user.uuid ? `/dashboard/${userData.user.uuid}` : "/"} />} />
      </Routes>
    </>
  );
};

export default AppRouter;
